import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { ExitGameDialog } from '../exit-game-dialog.component';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { ExitService } from 'src/app/services/exit.service';
import { ActivatedRoute } from '@angular/router';
import { JwtService } from 'src/app/services/jwt.service';

@Component({
  selector: 'app-play',
  templateUrl: './play.component.html',
  styleUrls: ['./play.component.css']
})
export class PlayComponent implements OnInit {
  game: string;
  url: string;
  urlSafe: SafeResourceUrl;

  constructor( private jwt: JwtService, private sanitizer: DomSanitizer, private dialog: MatDialog, private mixpanel: MixpanelService, private exitservice: ExitService, private activatedRoute: ActivatedRoute) {
    this.exitservice.exit = false;
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.game = params['game'];
      this.mixpanel.track("page_view", { page: this.game, category: "Games", button: "-"  });
    });
    this.jwt.check();
    this.url = `../../../../assets/js-games/${this.game}/index.html`;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  canDeactivate(): Observable<boolean> {
    if (!this.exitservice.exit) {
      const dialogRef = this.dialog.open(ExitGameDialog);
      return dialogRef.afterClosed().pipe(
        map((result) => {
          return result === true;
        })
      );
    } else {
      return of(true);
    }
  }

  exitgame() {
    this.exitservice.exitgame();
  }
}
